import {
  ConsumablePointsOperatorEnum,
  CouponTypeEnum,
  PlatformEnum,
  QrStateEnum,
  UserAccountStatusEnum,
} from 'src/shared/enums';
import { ICouponParams, IQrInfo, IUser } from 'src/shared/models';
import { customLandings, Blocks, DeviceEnum } from './customLandings';
import { config } from 'config/config';

export const isValidQr = (qrInfo?: IQrInfo) => {
  return qrInfo?.state === QrStateEnum.valid && !qrInfo?.consumed;
};

export const isUserValid = (user: IUser) => {
  return (
    user?.userStatus &&
    user?.validatedEmail &&
    [UserAccountStatusEnum.GRANT, UserAccountStatusEnum.PROFILING].includes(
      user.userStatus,
    )
  );
};

export const isUserBlacklisted = (user: IUser) => {
  return user?.blacklisted ? true : false;
};

export const cleanQueryParam = (url, param: string) => {
  const queryParams = new URLSearchParams(url.search);
  queryParams.delete(param);
  let restantUrl = `${window.location.pathname}?${queryParams}`;
  if (restantUrl[restantUrl.length - 1] === '?') {
    restantUrl = restantUrl.slice(0, -1);
  }
  window.history.replaceState({}, '', restantUrl);
};

/**
 * Retrieves the custom landing for the specified platform and consumable ID.
 * @param platform - The platform for which to retrieve the custom landing.
 * @param landingId - The ID of the custom landing to retrieve.
 * @returns The custom landing for the specified platform and landing ID, or undefined if not found.
 */
export const getCustomLanding = (
  platform: PlatformEnum,
  consumableId: number,
  screenWidth?: number,
): Blocks[] => {
  if (!screenWidth) return undefined;

  const landing = customLandings.get(consumableId);

  const device = getDevice(screenWidth);

  return landing &&
    landing[platform] &&
    landing[platform].availableDevices.includes(device)
    ? landing[platform].blocks
    : undefined;
};

export const getDevice = (screenWidth: number) => {
  return screenWidth < config.BREAKPOINTS.TABLET
    ? DeviceEnum.MOBILE
    : screenWidth <= config.BREAKPOINTS.DESKTOP &&
      screenWidth >= config.BREAKPOINTS.TABLET
    ? DeviceEnum.TABLET
    : DeviceEnum.DESKTOP;
};

export const isFirstScan = (coupon: ICouponParams): boolean => {
  return coupon?.type !== CouponTypeEnum.ADVOCACY
    ? false
    : coupon?.pointsOperator === ConsumablePointsOperatorEnum.MULTIPLY
    ? true
    : false;
};
